/* @flow */

import keymirror from 'keymirror';

const ViewConstants = keymirror({
  VIEW_LOAD: null,
  VIEW_SET_ACTIVE: null,
  VIEW_TOGGLE_MENU: null,
});

export { ViewConstants };
